/**
 * internal dependencies
 */
import { VEHICLE_POOL_FORM } from "../form-cardgroup-types";
import { useVehiclePin } from './vehicle-pin-helpers';

import { IPinPool } from '../../../../models/cardgroup.interface';
import { pinPoolWidget } from '../../../widgets/pinPoolWidget';

import ExportCsv from '../csv/export-csv';

/**
 * Displays the vehicle pin pool for a card group
 * 
 * @param {IPinPool} data - The pin pool data
 * 
 * @returns void
 */
const DisplayVehiclePins = (data: IPinPool) => {
  const { cardGroup, pinPool } = data.body;
  const { customerId, customerName, cardGroupName,cardGroupId } = cardGroup[0];

  const { vpCustomerName, vpCardGroupName, vpActive, vpFieldContainer } = VEHICLE_POOL_FORM;

  vpCustomerName.value = customerName ?? '';
  vpCustomerName.dataset.customerId = customerId.toString() ?? '';
  vpCardGroupName.value = cardGroupName ?? '';
  vpCardGroupName.dataset.cardGroupId = cardGroupId?.toString() ?? '';

  vpActive.checked = pinPool.length > 0;

  useVehiclePin(vpActive);
  vpActive.addEventListener('click', () => useVehiclePin(vpActive));

  pinPoolWidget(pinPool, vpFieldContainer);

  VEHICLE_POOL_FORM.vpExport.addEventListener('click', () => {
    VEHICLE_POOL_FORM.vpExport.classList.add('aafp_button-loading');
    ExportCsv(data, 'vehicle_pin');
  });
};

export default DisplayVehiclePins;